"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _helpers = require("../../utils/helpers");
var _AnchorTag = _interopRequireDefault(require("../utils/AnchorTag"));
var _NavListModule = _interopRequireDefault(require("./../../scss/lists/NavList.module.scss"));
function NavList({
  title = '',
  links = [],
  classname = '',
  useNavWrapper = false
}) {
  const titleSlug = (0, _helpers.slugify)(title);
  if (useNavWrapper) return /*#__PURE__*/_react.default.createElement("nav", {
    "aria-labelledby": title !== '' ? titleSlug : null,
    className: classname
  }, title !== '' && /*#__PURE__*/_react.default.createElement("h2", {
    id: title !== '' ? titleSlug : null,
    className: `h4`
  }, title), /*#__PURE__*/_react.default.createElement("ul", {
    className: `${classname}__nav-list ${_NavListModule.default['nav-list']}`
  }, links.map(link => {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: `${classname}__nav-item ${_NavListModule.default['nav-list__item']}`,
      key: `${classname}-${Math.round(Math.random() * 10000000)}`
    }, /*#__PURE__*/_react.default.createElement(_AnchorTag.default, {
      label: link.label,
      href: link.href,
      type: link.type,
      classname: `${classname}__nav-link`,
      image: link !== null && link !== void 0 && link.image ? link.image : null
    }));
  })));
  if (!useNavWrapper) return /*#__PURE__*/_react.default.createElement("div", {
    className: classname
  }, title !== '' && /*#__PURE__*/_react.default.createElement("h2", {
    className: `h4`
  }, title), /*#__PURE__*/_react.default.createElement("ul", {
    className: [`${classname}__nav-list`, _NavListModule.default['nav-list']].join(' ')
  }, links.map(link => {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: [`${classname}__nav-item`, _NavListModule.default['nav-list__item']].join(' '),
      key: `${classname}-${Math.round(Math.random() * 10000000)}`
    }, /*#__PURE__*/_react.default.createElement(_AnchorTag.default, {
      label: link.label,
      href: link.href,
      type: link.type,
      classname: `${classname}__nav-link`,
      image: link !== null && link !== void 0 && link.image ? link.image : null
    }));
  })));
}
var _default = exports.default = NavList;